import linksRule from '../../link/default';

const light = (params) => linksRule.light(params);

export default light;
